module.exports = __webpack_public_path__ + "img/ep-amande.f2466512.jpg";